import { render, staticRenderFns } from "./HeartOutline.vue?vue&type=template&id=2a97a268"
import script from "./HeartOutline.vue?vue&type=script&lang=js"
export * from "./HeartOutline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports